// extracted by mini-css-extract-plugin
export default {"question":"Mxn6mqPjqStZwi9ZG6LZ"};